module.exports = __webpack_public_path__ + "prod/1.42.2/img/head-img.8bbc5512.png";